// Curated, category-relevant real photography for generated websites.
const IMAGES = {
  cafe: [
    "https://images.unsplash.com/photo-1712730642507-d4ad0904e997?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.pexels.com/photos/20825644/pexels-photo-20825644.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.pexels.com/photos/2079448/pexels-photo-2079448.jpeg?auto=compress&cs=tinysrgb&w=1400",
  ],
  restaurant: [
    "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.pexels.com/photos/1327393/pexels-photo-1327393.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.pexels.com/photos/7627408/pexels-photo-7627408.jpeg?auto=compress&cs=tinysrgb&w=1400",
  ],
  salon: [
    "https://images.unsplash.com/photo-1585747860715-2ba37e788b70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.unsplash.com/photo-1647140655214-e4a2d914971f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  ],
  auto: [
    "https://images.pexels.com/photos/3807517/pexels-photo-3807517.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.unsplash.com/photo-1504222490345-c075b6008014?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.unsplash.com/photo-1570129476815-ba368ac77013?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  ],
  medical: [
    "https://images.pexels.com/photos/305567/pexels-photo-305567.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.unsplash.com/photo-1629909613654-28e377c37b09?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.pexels.com/photos/6812461/pexels-photo-6812461.jpeg?auto=compress&cs=tinysrgb&w=1400",
  ],
  fitness: [
    "https://images.unsplash.com/photo-1761971976282-b2bb051a5474?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.pexels.com/photos/6739958/pexels-photo-6739958.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.pexels.com/photos/7031705/pexels-photo-7031705.jpeg?auto=compress&cs=tinysrgb&w=1400",
  ],
  home_services: [
    "https://images.unsplash.com/photo-1660330589827-da8ab7dd3c02?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.unsplash.com/photo-1731168273756-e02cae42265b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  ],
  landscaping: [
    "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.unsplash.com/photo-1602254992120-5b3c3dad1d9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.unsplash.com/photo-1571974448718-ac26a9af7d8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  ],
  legal: [
    "https://images.unsplash.com/photo-1571974448718-ac26a9af7d8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.unsplash.com/photo-1602254992120-5b3c3dad1d9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.unsplash.com/photo-1602251223185-b1f2c7e5cad7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  ],
  generic: [
    "https://images.unsplash.com/photo-1571974448718-ac26a9af7d8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.unsplash.com/photo-1602254992120-5b3c3dad1d9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.unsplash.com/photo-1602251223185-b1f2c7e5cad7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  ],
};

export function getImages(categoryKey) {
  return IMAGES[categoryKey] || IMAGES.generic;
}
